import WhatsApp from './WhatsApp'
export default WhatsApp